(function () {
  var KEY = 'AB Assignment';
  var STORE = '_ab_assignment';
  var WAIT_MS = 4000;

  function ready() {
    var ig = window.igData;
    return ig && ig.user && typeof ig.user.getExperiments === 'function' && typeof ig.user.getTestGroup === 'function' ? ig : null;
  }

  function waitForIntelligems(maxMs) {
    return new Promise(function (resolve, reject) {
      var start = Date.now();
      var settled = false;
      function finish(ig) {
        if (settled) return;
        settled = true;
        if (ig) resolve(ig);
        else reject(new Error('intelligems unavailable'));
      }
      window.addEventListener('ig:ready', function () {
        finish(ready());
      });
      (function poll() {
        if (settled) return;
        var ig = ready();
        if (ig) return finish(ig);
        if (Date.now() - start > maxMs) return finish(null);
        setTimeout(poll, 50);
      })();
    });
  }

  function token(groupId) {
    var hex = String(groupId || '').replace(/-/g, '').toLowerCase();
    return /^[0-9a-f]{8,}$/.test(hex) ? hex.slice(-8) : null;
  }

  function label(value, fallback) {
    var text = String(value || fallback || '').replace(/\s*[|:]\s*/g, ' ').trim();
    return text || fallback;
  }

  function entries(ig) {
    var experiments = [];
    try {
      experiments = ig.user.getExperiments() || [];
    } catch (e) {
      return null;
    }
    var seen = {};
    var out = [];
    experiments.forEach(function (exp) {
      if (!exp || !exp.id || exp.isPreview) return;
      var group = null;
      try {
        group = ig.user.getTestGroup(exp.id);
      } catch (e) {}
      if (!group || !group.id) return;
      var tok = token(group.id);
      if (!tok || seen[tok]) return;
      seen[tok] = true;
      out.push({
        title: label(exp.name, exp.id),
        arm: label(group.name, group.isControl ? 'Control' : 'Variant'),
        token: tok
      });
    });
    return out;
  }

  function assignment(list) {
    return list
      .map(function (e) {
        return e.title + ':' + e.arm + ':' + e.token;
      })
      .join(' | ');
  }

  function abTestsParam(list) {
    var tokens = list.map(function (e) {
      return e.token;
    });
    while (tokens.length > 4 || tokens.join(',').length > 36) tokens.shift();
    return tokens.join(',');
  }

  function publish(list) {
    if (!list) return;
    if (typeof window.omniSetAbTests === 'function') window.omniSetAbTests(abTestsParam(list));
    send(assignment(list));
  }

  function send(value) {
    if (!value) return;
    try {
      if (sessionStorage.getItem(STORE) === value) return;
    } catch (e) {}
    var attrs = {};
    attrs[KEY] = value;
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ attributes: attrs })
    })
      .then(function (res) {
        if (!res.ok) return;
        try {
          sessionStorage.setItem(STORE, value);
        } catch (e) {}
      })
      .catch(function () {});
  }

  function run() {
    waitForIntelligems(WAIT_MS)
      .then(function (ig) {
        publish(entries(ig));
        setTimeout(function () {
          publish(entries(ig));
        }, 4000);
      })
      .catch(function () {});
  }

  function start() {
    setTimeout(run, 1500);
  }

  waitForIntelligems(WAIT_MS)
    .then(function (ig) {
      if (typeof window.omniSetAbTests === 'function') {
        var list = entries(ig);
        if (list) window.omniSetAbTests(abTestsParam(list));
      }
    })
    .catch(function () {});

  if (document.readyState === 'complete') {
    start();
  } else {
    window.addEventListener('load', start);
  }
})();
